import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const guaranteeItems = ['Explore all 6 volumes', 'Review the decision maps', 'Use the checklists', 'Work through the educational cases', 'Explore the complete system'];
export function GuaranteeSection() {
  return <section className="w-full bg-cream-100 py-14 sm:py-20" data-id="element-178" data-mp="eu8ydeua7smf">
      <div className="mx-auto w-full max-w-2xl px-4 sm:px-6" data-id="element-179" data-mp="jt294zi6p5iw">
        <div className="rounded-3xl border-2 border-clinical-green/35 bg-white p-6 shadow-card sm:p-8" data-id="element-180" data-mp="jqg2d234au1q">
          <div className="flex flex-col items-center text-center" data-id="element-181" data-mp="nrrj0i40k4xs">
            <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-clinical-green/10 text-clinical-green" data-id="element-182" data-mp="sldzkldassyv">
              <ShieldCheckIcon className="h-7 w-7" aria-hidden="true" data-id="element-183" data-mp="xlrwp8dd2ii4" />
            </span>
            <p className="mt-4 text-[11px] font-bold uppercase tracking-[0.14em] text-clinical-green" data-id="element-184" data-mp="12gxh22r47p43">
              7-day money-back guarantee
            </p>
            <h2 className="mt-3 font-display text-[24px] font-bold leading-tight text-navy-900 sm:text-3xl" data-id="element-185" data-mp="25sykwtyk9khr">
              Explore Occlusion 360™ risk-free
            </h2>
            <p className="mt-4 text-[15px] text-navy-700/80" data-id="element-186" data-mp="1vthf8cjb76ls">
              For the next 7 days, you can:
            </p>
          </div>

          <ul className="mt-5 grid gap-2 sm:grid-cols-2" data-id="element-187" data-mp="1rth2cwbuz3gu">
            {guaranteeItems.map(item => <li key={item} className="flex items-start gap-2.5 rounded-xl bg-cream-100 px-3.5 py-3" data-id="element-188" data-mp="2ohwu8z2fxox4">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-clinical-green/10 text-clinical-green" aria-hidden="true" data-id="element-189" data-mp="2esdalr6wlr17">
                  <CheckIcon className="h-3 w-3" data-id="element-190" data-mp="37964jak1chpr" />
                </span>
                <span className="text-[14px] font-medium leading-snug text-navy-800" data-id="element-191" data-mp="32i7nu9v4xhlz">
                  {item}
                </span>
              </li>)}
          </ul>

          <p className="mt-6 text-center text-[14px] leading-relaxed text-navy-700/80" data-id="element-192" data-mp="10mql37pyha39">
            If you decide that Occlusion 360™ doesn’t provide value for your
            professional development, you can request a refund within the guarantee
            period.{' '}
            <strong className="font-bold text-navy-900" data-id="element-193" data-mp="vscpb47dt0y2">No risk.</strong>
          </p>
        </div>

        <div className="mx-auto mt-8 w-full max-w-md" data-id="element-194" data-mp="hsl52lq9uobm">
          <CTAButton label="Try Occlusion 360™ for 7 days" subline="Instant access · One-time payment of $27 USD" data-id="element-195" data-mp="mtsbagcrnfg6" />
        </div>
      </div>
    </section>;
}